const appConfig = {
    appId: "insightQore-5ddc80c4-2772-4f82-a8dc-56a227bc1c97",
    appName: "Insight",
    site: 'insight-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/insightQoreAppIcon.png"
};

export default appConfig;
